import { TNodeProps } from '../types/node';
import { BaseNode } from './BaseNode';
import { StandardHandles } from './StandardHandles';

export const JoinNode = (props: TNodeProps) => {
  return (
    <BaseNode {...props}>
      <StandardHandles />
    </BaseNode>
  );
};
